import React from 'react'
import styles from './styles.module.css'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getCompetence, getCultureList, getEduDirList } from '../../../actions/courses'
import { Checkbox, Input, Select } from '../../../components/ModalInputs'
import cn from 'classnames'
import ModalFooter from '../../../components/ModalFooter/ModalFooter'
import { getLessons } from '../../../actions/common'

const statusList = [
  { name: 'Идет', value: '2' },
  { name: 'Закрыт', value: '1' },
]

const attestatKlassList = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11']

export default function Main({ closeModal, infoCreateChange, values, error, setFieldValue, handleChange, handleSubmit }) {

  const dispatch = useDispatch()
  const { loading, eduDirList, cultureListList, competenceList } = useSelector(state => state.courses)
  const { lessons } = useSelector(state => state.common)

  useEffect(() => {
    dispatch(getLessons())
    dispatch(getEduDirList())
    dispatch(getCultureList())
    dispatch(getCompetence())
  }, [])

  const onCheckClick = (e) => setFieldValue(e.target.name, Number(!values[e.target.name]))

  // «Спец. курс» и «Индивидуальный проект» — read-only флаги выбранной дисциплины (lessons)
  const selectedLesson = lessons?.find(lesson => String(lesson.lid) === String(values?.lid))
  const specialCourse = selectedLesson ? selectedLesson.special_course : values?.special_course
  const individualProject = selectedLesson ? selectedLesson.individual_project : values?.individual_project

  return (
    <>
      <div className={styles.modalMain}>
        <div className={styles.form}>
          <div className={cn(styles.field, styles.s6)}>
            <Input
              label='Название'
              name='title'
              value={values?.title}
              error={error('title')}
              onChange={handleChange}
              style={{ width: '100%' }}
            />
          </div>
          <div className={cn(styles.field, styles.s6)}>
            <Select
              label='Дисциплина'
              name='lid'
              value={values?.lid ?? ''}
              onChange={handleChange}
              style={{ width: '100%' }}
            >
              <option value=''>Не выбрано</option>
              {lessons?.map(({ lid, name }) => <option key={lid} value={lid}>{name}</option>)}
            </Select>
          </div>
          <div className={cn(styles.field, styles.s3)}>
            <Input
              label='Короткое название'
              name='alias'
              value={values?.alias}
              onChange={handleChange}
              style={{ width: '100%' }}
            />
          </div>
          <div className={cn(styles.field, styles.s3)}>
            <Select
              label='Статус'
              name='status'
              value={values?.status}
              onChange={handleChange}
              style={{ width: '100%' }}
            >
              {statusList.map(({ name, value }) => <option key={value} value={value}>{name}</option>)}
            </Select>
          </div>

          <div className={styles.checksRow}>
            <Checkbox
              label='Парный урок'
              name='xp_paired'
              checked={!!values?.xp_paired}
              onChange={onCheckClick}
            />
            <Checkbox
              label='Индивидуальный урок'
              name='isindividual'
              checked={!!values?.isindividual}
              onChange={onCheckClick}
            />
            <Checkbox
              label='Для всей параллели'
              name='isparallelcourse'
              checked={!!values?.isparallelcourse}
              onChange={onCheckClick}
            />
          </div>
          <div className={styles.checksRow}>
            <Checkbox
              label='Без домашнего задания'
              name='needhomework'
              checked={!!values?.needhomework}
              onChange={onCheckClick}
            />
            <Checkbox
              label='Приказ №352'
              name='p352'
              checked={!!values?.p352}
              onChange={onCheckClick}
            />
          </div>
          <div className={styles.checksRow}>
            <Checkbox
              label='Без оценок'
              name='neednt_grades'
              checked={!!values?.neednt_grades}
              onChange={onCheckClick}
            />
            <Checkbox
              label='Аттестат'
              name='skip_attestat'
              checked={!!values?.skip_attestat}
              onChange={onCheckClick}
            />
            <Checkbox
              label='ЕГЭ'
              name='ege'
              checked={!!values?.ege}
              onChange={onCheckClick}
            />
            <Checkbox
              label='ОГЭ'
              name='gia'
              checked={!!values?.gia}
              onChange={onCheckClick}
            />
          </div>

          <div className={styles.divider} />

          <div className={cn(styles.field, styles.s2)}>
            <Select
              label='Образовательное направление'
              name='c_edu_direction'
              value={values?.c_edu_direction ?? ''}
              onChange={handleChange}
              style={{ width: '100%' }}
            >
              <option value=''>Не выбрано</option>
              {eduDirList?.map(({ name, id }) => <option key={id} value={id}>{name}</option>)}
            </Select>
          </div>
          <div className={cn(styles.field, styles.s2)}>
            <Select
              label='Культура'
              name='c_culture'
              value={values?.c_culture ?? ''}
              onChange={handleChange}
              style={{ width: '100%' }}
            >
              <option value=''>Не выбрано</option>
              {cultureListList?.map(({ name, id }) => <option key={id} value={id}>{name}</option>)}
            </Select>
          </div>
          <div className={cn(styles.field, styles.s2)}>
            <Select
              label='Компетентность'
              name='c_competence'
              value={values?.c_competence ?? ''}
              onChange={handleChange}
              style={{ width: '100%' }}
            >
              <option value=''>Не выбрано</option>
              {competenceList?.map(({ name, id }) => <option key={id} value={id}>{name}</option>)}
            </Select>
          </div>

          <div className={cn(styles.field, styles.s2)}>
            <Input
              label='Сортировка'
              name='xp_sort'
              value={values?.xp_sort ?? ''}
              onChange={handleChange}
              type='number'
              onInput={(e) => e.target.value = e.target.value.slice(0, 9)}
            />
          </div>
          <div className={cn(styles.checkboxCell, styles.s2)}>
            <Checkbox
              label='Отчет ВШЭ'
              name='reporthse'
              checked={!!values?.reporthse}
              onChange={onCheckClick}
            />
          </div>
          <div className={cn(styles.field, styles.s4)}>
            <Input
              label='Сортировка для отчёта «Классный журнал(полный)»'
              name='report_sort'
              value={values?.report_sort ?? ''}
              onChange={handleChange}
              type='number'
              onInput={(e) => e.target.value = e.target.value.slice(0, 9)}
            />
          </div>

          <div className={cn(styles.checkboxCell, styles.s6)}>
            <Checkbox
              label='Действуют освобождения от физкультуры'
              name='osvobojdeniefiz'
              checked={!!values?.osvobojdeniefiz}
              onChange={onCheckClick}
            />
          </div>

          <div className={cn(styles.field, styles.s2)}>
            <Input
              label='Сортировка для аттестата'
              name='sort'
              value={values?.sort ?? ''}
              onChange={handleChange}
              type='number'
              onInput={(e) => e.target.value = e.target.value.slice(0, 9)}
            />
          </div>

          <div className={styles.checksRow}>
            <Checkbox
              label='Спец. курс'
              name='special_course'
              checked={!!Number(specialCourse)}
              disabled
            />
            <Checkbox
              label='Индивидуальный проект'
              name='individual_project'
              checked={!!Number(individualProject)}
              disabled
            />
          </div>

          <div className={cn(styles.field, styles.s6)}>
            <Input
              label='Название для аттестата'
              name='attestattitle'
              value={values?.attestattitle ?? ''}
              onChange={handleChange}
              style={{ width: '100%' }}
            />
          </div>
          <div className={cn(styles.field, styles.s2)}>
            <Select
              label='Класс для аттестата'
              name='attestatklass'
              value={values?.attestatklass ?? ''}
              onChange={handleChange}
              style={{ width: '100%' }}
            >
              <option value=''>-</option>
              {attestatKlassList.map(klass => <option key={klass} value={klass}>{klass}</option>)}
            </Select>
          </div>
        </div>
      </div>
      <ModalFooter closeModal={closeModal} loading={loading} handleSubmit={handleSubmit} infoCreateChange={infoCreateChange} />
    </>
  )
}
